import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import AnimatedNumber from "react-animated-number";

export default function StatsHero({
  value = 2838217,
  initialValue = 1500000,
  text = "изчистени соларни панела в България с препаратите на",
  Chemitek = "../images/chemitek.png",
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  // Ensure numbers
  const numValue = Number(value);
  const numInitialValue = Number(initialValue);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer && observer.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",
        maxWidth: 1200,
        mx: "auto",
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 4 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 2, md: 6 },
        textAlign: "center",
      }}
    >
      {/* Number */}
      <Box
        sx={{
          flexShrink: 0,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.9)",
          transition: "all 0.8s ease-out",
        }}
      >
        <AnimatedNumber
          initialValue={numInitialValue}
          value={visible ? numValue : numInitialValue}
          duration={1800}
          stepPrecision={0}
          formatValue={(n) =>
            Intl.NumberFormat("bg-BG", { maximumFractionDigits: 0 }).format(n)
          }
          style={{
            fontSize: "36px", // default mobile
            fontWeight: 700,
            color: "#2f4f7f",
            display: "inline-block",
            animation: visible ? "pulse 1.2s ease-out" : "none",
          }}
        />
      </Box>

      {/* Text */}
      <Typography
        variant="h6"
        sx={{
          color: "#2f4f7f",
          fontWeight: 500,
          maxWidth: { xs: "100%", md: 400 },
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(20px)",
          transition: "all 1s ease-out 0.3s",
        }}
      >
        {text}
      </Typography>

      {/* Logo */}
      <Box
        sx={{
          flexShrink: 0,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(20px)",
          transition: "all 1s ease-out 0.5s",
        }}
      >
        <Box
          component="img"
          src={Chemitek}
          alt="Logo"
          sx={{ height: 42, width: "auto" }}
        />
      </Box>

      {/* Pulse animation keyframes */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.08); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </Box>
  );
}
